import { Headphones } from "lucide-react";
import { PortalLoginForm } from "@/components/auth/PortalLoginForm";
import { ROUTES } from "@/constants/routes";

export default function OpsLogin() {
    return (
        <PortalLoginForm
            portal="ops"
            title="Operations Admin"
            subtitle="Cross-store operations & analytics."
            homePath={ROUTES.opsDashboard}
            accent="bg-indigo-600"
            icon={<Headphones className="h-5 w-5" />}
            testId="ops-login-page"
        />
    );
}
